import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ReorderLoadsService {

  private assignEventSource = new Subject<void>();
  private unassignEventSource = new Subject<void>();
  private chosenVehicleEventSource = new Subject<string>();

  assignEvent = this.assignEventSource.asObservable();
  unassignEvent = this.unassignEventSource.asObservable();
  chosenVehicleEvent = this.chosenVehicleEventSource.asObservable();

  assignLoad() {
    this.assignEventSource.next();
  }

  unassignLoad() {
    this.unassignEventSource.next();
  }
  chosenVehicle(vehicle: string) {
    this.chosenVehicleEventSource.next(vehicle);
  }

}
